import {PIXI} from '@colonist/pixi'
import {GameEndChartColumnData} from './UIGameEndChartColumnView'
import {UIGameEndChartView} from './UIGameEndChartView'

export class GameEndStatsDiceStatsView extends UIGameEndChartView {
    private readonly labels: number[] = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, diceStats: number[]) {
        super(x, y, w, h, container, diceStats.length, {key: 'strings:game.endGame.dice.rolls'})

        this.createDiceStats(diceStats)
        this.drawChart()
    }

    private createDiceStats(diceStats: number[]) {
        for(const [index, diceStat] of diceStats.entries()) {
            if(diceStat == undefined) continue
            const columnData: GameEndChartColumnData = {
                label: this.labels[index],
                amount: diceStat,
            }
            this.columnDataArray.push(columnData)
        }
    }
}
